export default {
  defaultDisplayName: 'Nový virtuálny signál',
};
